const bootstrap = require('bootstrap');

import {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  Offcanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip,
} from 'bootstrap';

// Make available globally
window.Alert = Alert;
window.Button = Button;
window.Carousel = Carousel;
window.Collapse = Collapse;
window.Dropdown = Dropdown;
window.Modal = Modal;
window.Offcanvas = Offcanvas;
window.Popover = Popover;
window.ScrollSpy = ScrollSpy;
window.Tab = Tab;
window.Toast = Toast;
window.Tooltip = Tooltip;



let isSmartPhone = () => {
  if (window.matchMedia && window.matchMedia('(max-device-width: 640px)').matches) {
    for (let i = 1; i <= 6; i++) {
      var footerCollapsible = document.getElementById('footer-menu-column-' + i);
      var collapse = new bootstrap.Collapse(footerCollapsible, {
        hide: true
      });
      //console.log( i );
    }
    return true;
  } else {
    return false;
  }
}
isSmartPhone();
